import { combineReducers } from 'redux'

import { reducer as organizationInvitations } from './organization_invitations/slice'
import { reducer as organizationMemberships } from './organization_memberships/slice'

export const reducer = combineReducers({
  organizationMemberships,
  organizationInvitations,
})
